/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.22.0-beta.6-6-gfde9e530-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AdminRoleDataRequest interface.
 */
export function instanceOfAdminRoleDataRequest(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('targetsCreate' in value) || value['targetsCreate'] === undefined)
        return false;
    if (!('targetsEdit' in value) || value['targetsEdit'] === undefined)
        return false;
    if (!('targetsDelete' in value) || value['targetsDelete'] === undefined)
        return false;
    if (!('usersCreate' in value) || value['usersCreate'] === undefined)
        return false;
    if (!('usersEdit' in value) || value['usersEdit'] === undefined)
        return false;
    if (!('usersDelete' in value) || value['usersDelete'] === undefined)
        return false;
    if (!('accessRolesCreate' in value) || value['accessRolesCreate'] === undefined)
        return false;
    if (!('accessRolesEdit' in value) || value['accessRolesEdit'] === undefined)
        return false;
    if (!('accessRolesDelete' in value) || value['accessRolesDelete'] === undefined)
        return false;
    if (!('accessRolesAssign' in value) || value['accessRolesAssign'] === undefined)
        return false;
    if (!('sessionsView' in value) || value['sessionsView'] === undefined)
        return false;
    if (!('sessionsTerminate' in value) || value['sessionsTerminate'] === undefined)
        return false;
    if (!('recordingsView' in value) || value['recordingsView'] === undefined)
        return false;
    if (!('ticketsCreate' in value) || value['ticketsCreate'] === undefined)
        return false;
    if (!('ticketsDelete' in value) || value['ticketsDelete'] === undefined)
        return false;
    if (!('configEdit' in value) || value['configEdit'] === undefined)
        return false;
    if (!('adminRolesManage' in value) || value['adminRolesManage'] === undefined)
        return false;
    return true;
}
export function AdminRoleDataRequestFromJSON(json) {
    return AdminRoleDataRequestFromJSONTyped(json, false);
}
export function AdminRoleDataRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'targetsCreate': json['targets_create'],
        'targetsEdit': json['targets_edit'],
        'targetsDelete': json['targets_delete'],
        'usersCreate': json['users_create'],
        'usersEdit': json['users_edit'],
        'usersDelete': json['users_delete'],
        'accessRolesCreate': json['access_roles_create'],
        'accessRolesEdit': json['access_roles_edit'],
        'accessRolesDelete': json['access_roles_delete'],
        'accessRolesAssign': json['access_roles_assign'],
        'sessionsView': json['sessions_view'],
        'sessionsTerminate': json['sessions_terminate'],
        'recordingsView': json['recordings_view'],
        'ticketsCreate': json['tickets_create'],
        'ticketsDelete': json['tickets_delete'],
        'configEdit': json['config_edit'],
        'adminRolesManage': json['admin_roles_manage'],
    };
}
export function AdminRoleDataRequestToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'description': value['description'],
        'targets_create': value['targetsCreate'],
        'targets_edit': value['targetsEdit'],
        'targets_delete': value['targetsDelete'],
        'users_create': value['usersCreate'],
        'users_edit': value['usersEdit'],
        'users_delete': value['usersDelete'],
        'access_roles_create': value['accessRolesCreate'],
        'access_roles_edit': value['accessRolesEdit'],
        'access_roles_delete': value['accessRolesDelete'],
        'access_roles_assign': value['accessRolesAssign'],
        'sessions_view': value['sessionsView'],
        'sessions_terminate': value['sessionsTerminate'],
        'recordings_view': value['recordingsView'],
        'tickets_create': value['ticketsCreate'],
        'tickets_delete': value['ticketsDelete'],
        'config_edit': value['configEdit'],
        'admin_roles_manage': value['adminRolesManage'],
    };
}
